<template lang="">
    <div>
        <h3 class="text-center mt-5 text-danger">You are not authorized for this page! </h3>
    </div>
</template>
<script>
export default {
    name:'UnAuthorized'
}
</script>